import LanguageSwitcher from 'components/LanguageSwitcher'
import WhiteSpace from 'components/WhiteSpace'
import React from 'react'
import _ from 'lodash'
import { isBOTIM } from 'utils'
import { BOTIM_MONEY_LOGO_WHITE } from 'utils/botimBrand'
// import classes from './styles.module.scss'
// import messages from './messages'
// import { FormattedMessage } from 'react-intl'

export default class Header extends React.Component {
  render() {
    const { siteConfig, showLanguageSwitcher } = this.props
    return (
      <div className='clearfix'>
        {(showLanguageSwitcher ||
          _.get(siteConfig, 'pageCustomize.showLanBtn') === true) && (
          <div className='pull-right' style={{ lineHeight: '30px' }}>
            <LanguageSwitcher siteConfig={siteConfig} />
          </div>
        )}
        <div className='pull-left' style={{ display: 'flex', alignItems: 'center', minHeight: 30 }}>
          {window.history.length > 1 ? (
            <span
              className='icon iconfont fill_icon iconarrow-long font-20'
              onClick={() => window.history.back()}
            />
          ) : null}
          {isBOTIM() ? (
            <img
              src={BOTIM_MONEY_LOGO_WHITE}
              alt='Botim Money'
              height={26}
              style={{ marginLeft: window.history.length > 1 ? 12 : 0, display: 'block' }}
            />
          ) : null}
          {!isBOTIM() && window.history.length <= 1 ? <WhiteSpace /> : null}
        </div>
      </div>
    )
  }
}
